const Urls = {
    "MobileHomeUrl": "http://mobile.gmarket.co.kr",
    "LoginUrl": "https://mobile.gmarket.co.kr/Login/Login?URL="
}

export default Urls;


// WEBPACK FOOTER //
// ./src/urls.js